export const product = {
  id: "flower-printed-set",
  name: "Flower Printed Set",
  fullName: "Flower Printed Set — Cotton Kurta with Pyjama (Pack of 2)",
  subtitle: "Cotton Kurta with Matching Pyjama — Pack of 2",
  slug: "flower-printed-set",
  price: 599,
  originalPrice: 999,
  discount: "40% off",
  rating: 4.4,
  ratingCount: 12,
  ratingSource: "Verified Buyers",
  inStock: true,
  sizes: ["M", "L", "XL", "XXL"],
  sizeInfo: "All sizes in stock",
  images: [
    {
      src: "/images/product-front.jpg",
      alt: "Teal floral cotton kurta and pyjama set — front view",
    },
    {
      src: "/images/product-back.jpg",
      alt: "Teal floral cotton kurta and pyjama set — back view",
    },
    {
      src: "/images/product-side.jpg",
      alt: "Teal floral cotton kurta and pyjama set — side view",
    },
    {
      src: "/images/product-detail.jpg",
      alt: "Teal floral cotton kurta and pyjama set — folded flatlay",
    },
  ],
  thumbnail: "/images/product-thumbnail.jpg",
  heroImage: "/images/product-hero.jpg",
  specs: {
    fabric: "Cotton",
    set: "Kurta + Pyjama (Pack of 2)",
    fit: "A-line",
    length: "Calf",
    neck: "Round",
    sleeve: "3/4",
    pattern: "Floral Applique",
    colour: "Teal Blue",
    stitch: "Stitched",
    occasion: "Daily Wear",
    country: "India",
  },
  description: [
    "The Flower Printed Set pairs a soft cotton kurta with matching pyjama bottoms in an elegant teal-blue floral print. Breathable and skin-friendly, it\u2019s made to keep you comfortable from morning to evening.",
    "With its A-line silhouette, calf length, and delicate applique detailing, it moves easily from everyday wear to casual outings \u2014 effortless ethnic elegance you\u2019ll reach for again and again.",
  ],
  razorpayUrl: "#",
  whatsappNumber: "919358208560",
  shipping: 30,
  totalPrice: 629,
};

export const reviews = [
  {
    id: 1,
    name: "Priya S.",
    rating: 5,
    text: "Beautiful colour and great quality. Loved the fabric — so soft and comfortable. The print looks even better in person. Will definitely buy more!",
    date: "2 weeks ago",
    source: "Verified",
  },
  {
    id: 2,
    name: "Anjali K.",
    rating: 4,
    text: "Nice fit and elegant look. The pyjama is also well-stitched. Good value for money. Delivery was quick too.",
    date: "1 month ago",
    source: "Verified",
  },
  {
    id: 3,
    name: "Ritika M.",
    rating: 4,
    text: "Perfect daily wear. Comfortable cotton, true to size. The teal shade is very pretty. Ordered M and it fits perfectly.",
    date: "3 weeks ago",
    source: "Verified",
  },
  {
    id: 4,
    name: "Neha R.",
    rating: 5,
    text: "Amazing quality for the price. The pack of 2 is such a good deal. My mother also loved it. Will order again.",
    date: "2 days ago",
    source: "Verified",
  },
  {
    id: 5,
    name: "Sunita D.",
    rating: 5,
    text: "Exactly as shown in the pictures. The floral print is subtle and classy. Great for office and casual outings.",
    date: "1 week ago",
    source: "Verified",
  },
];

export const trustFeatures = [
  {
    icon: "ri-t-shirt-line",
    title: "Pure Cotton Comfort",
    description: "Breathable, skin-friendly cotton that keeps you comfortable all day.",
  },
  {
    icon: "ri-gift-line",
    title: "Kurta + Pyjama Set",
    description: "Complete 2-piece set — kurta with matching printed pyjama bottoms.",
  },
  {
    icon: "ri-arrow-go-back-line",
    title: "7-Day Easy Returns",
    description: "Not satisfied? Return within 7 days for a hassle-free refund.",
  },
  {
    icon: "ri-shield-check-line",
    title: "Secure Online Payment",
    description: "Pay safely via Razorpay — encrypted, trusted, and instant order confirmation.",
  },
];

export const brandInfo = {
  name: "NeoRoop",
  tagline: "Effortless ethnic, everyday grace.",
  parent: "NeoCave",
  contactName: "Mr. Aadil Zargam",
  whatsapp: "+91 9358208560",
  email: "contact@neoroop.com",
  address: "Meerut, Uttar Pradesh, India",
  instagram: "https://instagram.com",
  facebook: "https://facebook.com",
  shippingNote: "Flat ₹30 shipping across India",
  returnPolicy: "7-day easy returns and exchange",
};